import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full pt-20 pb-24 px-6 md:px-12 lg:px-24 bg-cream flex flex-col items-center justify-center min-h-screen" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-110">
          <span className="text-amber font-semibold tracking-wider uppercase text-sm mb-6 block" data-id="element-111">
            The Meltdown Vault — Crisis Calm Method
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-tight mb-16" data-id="element-112">
            The 3-Step Protocol That Stops Meltdowns in Minutes — Without
            Yelling, Punishing or Losing Yourself in the Process
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="max-w-2xl mx-auto text-left space-y-6 text-lg md:text-xl text-charcoal-light font-serif leading-relaxed" data-id="element-113">
          <p className="italic text-center mb-10 text-charcoal" data-id="element-114">
            It's 6:47 PM on a Tuesday.
          </p>
          <p data-id="element-115">
            Dinner is on the table. His favorite. The pasta he asked for three
            days in a row last week.
          </p>
          <p data-id="element-116">
            And in the time it took you to set down the serving spoon, something
            shifted.
          </p>
          <p data-id="element-117">
            You saw it in his eyes first. That look. The one that tells you the
            next thirty seconds are going to decide how the entire night ends.
          </p>
          <p data-id="element-118">
            You tried to redirect. You lowered your voice. You moved the plate
            slightly to the left the way you read somewhere might help.
          </p>
          <p data-id="element-119">It didn't matter.</p>
          <p data-id="element-120">
            By 6:52, dinner was over. He was in his room. You were standing at
            the sink with the water running, not because you needed to wash
            anything, but because you needed somewhere to put your hands while
            you held yourself together.
          </p>
          <div className="pt-8 text-center space-y-4" data-id="element-121">
            <p className="font-semibold text-charcoal text-2xl" data-id="element-122">
              This is not a parenting failure.
            </p>
            <p className="font-semibold text-charcoal text-2xl" data-id="element-123">
              This is a nervous system that nobody taught you how to read.
            </p>
            <p className="font-semibold text-amber text-2xl pt-4" data-id="element-124">
              And that ends today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}